import React, { useState } from 'react';
import { LoginPage } from './LoginPage';
import { RegisterPage } from './RegisterPage';

type AuthMode = 'login' | 'register';

export const AuthPage: React.FC = () => {
  const [mode, setMode] = useState<AuthMode>('login');

  if (mode === 'register') {
    return <RegisterPage onSwitchToLogin={() => setMode('login')} />;
  }

  return <LoginPage onSwitchToRegister={() => setMode('register')} />;
};

export default AuthPage;
